// extracted by mini-css-extract-plugin
export default {"container":"seek-bar_container__8Of8N","desktop":"seek-bar_desktop__tidSG","slider":"seek-bar_slider__5bzWx","progress":"seek-bar_progress__JCBRM"};